$(document).ready(function () {
  Sceon.AlertMe = {};
  let areas = [];
  let profileId = window.Escort.escort_id;
  $(document).on('click', '.add-city', function () {
    let area_id = $('#area_id').val();
    getAreas();
    if (area_id && !areas.includes(area_id)) {
      let area_name = $('#area_id option:selected').text();
      let line =
        '<div class="city-item-wr">' +
        area_name +
        '<a class="link-btn primary-light remove-city" data-area-id="' +
        area_id +
        '"><i class="sc-and6 sc-and6-close"></i></a></div>';
      $('.cities-list').append(line);
      areas.push(city_id);
    }
  });

  $(document).on('submit', '.alert-me-form', function () {
    event.preventDefault();
  });

  $(document).on('click', '.alert-me-modal .reset-btn', function () {
    $('.alert-me-modal input[type="checkbox"]').prop('checked', false);
    areas = [];
    $('input[type="checkbox"]').removeAttr('disabled');
    $('.alert-me-modal .city-item-wr').remove();
    $('.city-select').addClass('hidden');
  });

  $(document).on('click', '.remove-city', function () {
    let area_id = $(this).attr('data-area-id');
    let ind = areas.indexOf(area_id);
    if (ind > -1) {
      areas.splice(ind, 1);
    }
    $(this).closest('.city-item-wr').remove();
  });

  $(document).on('change', 'input[name="geo_nodes"]', function () {
    if (!$(this).is(':checked')) {
      areas = [];
      $('.city-item-wr').remove();
      $('.city-select').addClass('hidden');
    } else {
      $('.city-select').removeClass('hidden');
    }
  });

  $(document).on('change', 'input[name="any"]', function () {
    if (!$(this).is(':checked')) {
      $(
        'input.form-check-input:not([name="geo_nodes"],[name="any"])',
      ).removeAttr('disabled', 'disabled');
    } else {
      $('input.form-check-input:not([name="geo_nodes"],[name="any"])')
        .prop('checked', false)
        .attr('disabled', 'disabled');
    }
  });

  Sceon.AlertMe.Send = function () {
    let alm_overlay = new Sceon.Overlay($('.alert-me-modal .modal-content'), {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0, left: '1px' },
    });
    alm_overlay.enable();
    let id;
    if ($('#alm-id').length && $('#alm-id').val() !== 'undefined') {
      id = $('#alm-id').val();
    } else {
      id = '';
    }
    getAreas();
    let events = {};
    $('.popup-form input[type="checkbox"]:checked').each(function (ind, el) {
      let name = $(el).attr('name');
      if (name !== 'area') {
        if (name === 'any') {
          $('input.form-check-input:not([name="geo_nodes"],[name="any"])').each(
            (ind, el) => {
              events[$(el).attr('name')] = 1;
            },
          );
        } else {
          events[name] = 1;
        }
      }

      if (areas.length) {
        events.geo_nodes = areas;
      } else {
        events.geo_nodes = null;
      }
    });

    $.ajax({
      url: '/sex-model/ajax-alerts',
      method: 'POST',
      data: {
        profile_id: profileId,
        events,
        id,
      },
      success: function (resp) {
        if (resp.count > 0) {
          $('#alm-id').val(resp.id);
          $('#profile-dialog').find('.modal-close').trigger('click');
          if (Object.keys(events) && Object.keys(events).length) {
            $('.alert-me').addClass('action-active');
          } else {
            $('.alert-me').removeClass('action-active');
          }
        } else {
          $('#profile-dialog').find('.modal-close').trigger('click');
          $('#profile-dialog').html('');
        }
      },
    });
    setTimeout(() => {
      alm_overlay.disable();
    }, 300);
  };

  function getAreas() {
    if ($('.city-item-wr').length) {
      $('.city-item-wr').each(function (ind, ar) {
        let ar_id = $(ar).find('a.remove-city').attr('data-area-id');
        if (!areas.includes(ar_id)) {
          areas.push(ar_id);
        }
      });
    }
  }
});
